<ion-header>
  <app-header></app-header>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="calls-wrap page-width-and-shadow">
    <div class="title my-color-blue">{{ "__CALLS_CALL_HISTORY__" | translate }}</div>
    <app-user-calls-overview
      *ngIf="callsList"
      [callList]="callsList"
      (viewRecord)="viewRecord($event)">
    </app-user-calls-overview>
  </div>
</ion-content>
